import { Button, Card, Modal, Tag, Typography } from "antd";
import moment from "moment";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { saveUserDetails } from "redux/roles/userRoleSlice";
import {
  PaymentStatusColor,
  PaymentStatusEnum,
  convertToPlanDate,
  downloadEvent,
} from "utilities/generalUtility";
const { Title, Paragraph } = Typography;

export default function Payments({ userData, settings }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [btnLoading, setBtnloading] = useState(false);
  const [cancelLoading, setcancelLoading] = useState(false);
  const [manageBtnLoading, setManageLoading] = useState(false);

  const dispatch = useDispatch();
  const [open, setopen] = useState(false);

  const params = `?diaryId=${queryParams.get(
    "diaryId"
  )}&diaryTopicId=${queryParams.get("diaryTopicId")}`;

  const fetchManageApi = async () => {
    try {
      setManageLoading(true);
      const body = {
        returnUrl: `${process.env.REACT_APP_BASE_URL}journal-request${
          queryParams.get("diaryId") ? params : ""
        }`,
      };
      const res = await NetworkCall.fetch(
        Request.modifyCheckoutSession(body),
        false
      );
      downloadEvent("ManageSubscription");
      window.location.href = res?.data?.url;
      setManageLoading(false);
    } catch (error) {}
  };

  const fetchRenewUrl = async () => {
    try {
      setBtnloading(true);

      const body = {
        successUrl: `${process.env.REACT_APP_BASE_URL}journal-request${
          queryParams.get("diaryId") ? params : ""
        }`,
        cancelUrl: `${process.env.REACT_APP_BASE_URL}account-settings${
          queryParams.get("diaryId") ? params : ""
        }`,
      };
      const res = await NetworkCall.fetch(
        Request.createCheckoutSession(body),
        false
      );

      window.location.href = res?.data?.url;
      setBtnloading(false);
    } catch (error) {}
  };

  const cancelSubsciption = async () => {
    try {
      setcancelLoading(true);
      const res = await NetworkCall.fetch(Request.cancelSubscription(), false);
      downloadEvent("CancelSubscription");

      const temp = {
        ...userData,
        cancelAtPeriodEnd: res?.data?.cancelAtPeriodEnd,
        subscriptionStatus: res?.data?.subscriptionStatus,
      };

      dispatch(saveUserDetails(temp));
      setcancelLoading(false);
      setopen(false);
    } catch (error) {}
  };

  const danger =
    userData?.subscriptionStatus === "canceled" ||
    userData?.subscriptionStatus === "incomplete" ||
    userData?.subscriptionStatus === "past_due" ||
    userData?.subscriptionStatus === "incomplete_expired";
  const cancelStatement = (trial) => (
    <div>
      {`Your payment plan has been cancelled effective from ${convertToPlanDate(
        moment,
        userData?.subscriptionExpiryDate
      )} (UTC)`}
      <ul className="arrow-list">
        <li>{`You will not be charged ${
          trial ? "after trial period ends." : "from next month."
        }`}</li>
        <li>{`You will be able to use the app ${
          trial
            ? "in duration of trial period."
            : "till the current payment plan expires."
        }`}</li>
        <li>{`You can subscribe again anytime${
          trial ? " during or after trial period." : "."
        }`}</li>
      </ul>
    </div>
  );

  return (
    <Card className="payment-detail-card">
      <h2>Plan Details</h2>
      <Card type="inner" className="payemnt-detail-inner">
        <div className=" patment-detail-header">
          <div>
            <h4>{`$${settings?.RecurringSubscriptionAmount}`}</h4>
            <p>Per Month Charges</p>
          </div>
          <Tag
            color={
              userData?.cancelAtPeriodEnd
                ? "red"
                : PaymentStatusColor[userData?.subscriptionStatus] ?? "red"
            }
          >
            {PaymentStatusEnum[userData?.subscriptionStatus] ??
              userData?.subscriptionStatus}
          </Tag>
        </div>
        <p
          className={
            danger || userData?.cancelAtPeriodEnd
              ? "text-danger"
              : "text-default"
          }
        >
          {userData?.subscriptionStatus === "canceled" ||
          userData?.subscriptionStatus === "incomplete_expired"
            ? cancelStatement(false)
            : userData?.subscriptionStatus === "incomplete" ||
              userData?.subscriptionStatus === "past_due"
            ? "Your plan is expired"
            : userData?.cancelAtPeriodEnd
            ? cancelStatement(
                userData?.subscriptionStatus === "trialing" ? true : false
              )
            : ` Your plan will renew on ${convertToPlanDate(
                moment,
                userData?.subscriptionExpiryDate
              )} (UTC)`}
        </p>
      </Card>
      <div className="payment-btns">
        <Button
          block
          size="large"
          danger={danger ? true : false}
          type="primary"
          onClick={fetchManageApi}
          loading={manageBtnLoading}
        >
          {"Manage Subscription"}
        </Button>
        {userData?.subscriptionStatus === "canceled" ||
        userData?.subscriptionStatus === "incomplete_expired" ? (
          <Button
            block
            size="large"
            type="ghost"
            onClick={fetchRenewUrl}
            loading={btnLoading}
          >
            Renew Subscription
          </Button>
        ) : (
          <Button
            block
            size="large"
            type="ghost"
            onClick={() => setopen(true)}
            disabled={
              userData?.cancelAtPeriodEnd ||
              userData?.subscriptionStatus === "canceled"
            }
          >
            Cancel Subscription
          </Button>
        )}
      </div>
      <Modal
        centered
        mask={false}
        open={open}
        onOk={cancelSubsciption}
        onCancel={() => setopen(false)}
        closable={false}
        className="post-confirmation-modal"
        okText="Yes"
        cancelText="No"
        okButtonProps={{
          loading: cancelLoading,
        }}
        cancelButtonProps={{
          ghost: true,
        }}
      >
        <Title level={4}>Confirmation</Title>
        <Paragraph className="text">
          Are you sure, you want to cancel your subscription?
        </Paragraph>
      </Modal>
    </Card>
  );
}
